import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="max-w-lg mx-auto py-16 text-center space-y-6" data-testid="payment-cancel-page">
      <div className="w-16 h-16 mx-auto rounded-full bg-red-500/20 border border-red-500 flex items-center justify-center">
        <XCircle size={32} className="text-red-400" />
      </div>
      <div>
        <p className="ft-overline text-red-400">PAYMENT CANCELLED</p>
        <h1 className="font-display text-4xl font-black tracking-tighter mt-1">No card was charged.</h1>
        <p className="mt-2 text-sm text-[var(--text-muted)]">You cancelled before finishing checkout. You can pick a plan again whenever you're ready.</p>
      </div>
      <button
        type="button"
        onClick={() => nav("/profile?tab=subscription", { replace: true })}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#FF5A1F] hover:bg-[#E64A0F] text-white text-sm font-semibold"
        data-testid="payment-cancel-back-btn"
      >
        <ArrowLeft size={14} /> Back to Manage Subscription
      </button>
    </div>
  );
}
